<app-toaster></app-toaster>
<div class="po-row">
  <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
    <p class="po-font-title">Conferência de embarque</p>
  </div>
</div>

<div class="po-row">
  <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
    <app-scanner (scannedData)="onScannedInvoice($event)">
    </app-scanner>
  </div>
</div>

<div class="po-row po-mt-2">
  <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
    <po-container>
      <div class="po-row">
        <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12 po-mb-1">
          <span class="po-font-text-large-bold">Lista de conferências</span>
        </div>
      </div>
      <div class="po-row">
        <div class="po-xl-5 po-lg-5 po-md-12 po-sm-12" [formGroup]="filterForm">
          <po-datepicker
            p-label="Data"
            name="filterDate"
            formControlName="filterDate"
            p-clean="true"
          ></po-datepicker>
        </div>
        <div class="po-xl-5 po-lg-5 po-md-12 po-sm-12">
          <po-select
            name="statusFilter"
            p-label="Status"
            [p-options]="statusFilterOptions"
            [ngModel]="statusFilter"
            (ngModelChange)="onStatusFilterChange($event)">
          </po-select>
        </div>
        <div class="po-xl-2 po-lg-2 po-md-12 po-sm-12">
          <po-button
            p-label="Filtrar"
            p-kind="primary"
            (p-click)="onFilterClick()"
            class="po-mt-4">
          </po-button>
        </div>
      </div>
      <div class="po-row">
        <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
          <div class="invoice-list-container" (scroll)="onScroll($event)">
            <div class="invoice-list">
              <ng-container *ngIf="displayInvoiceList.length > 0; else innerNoItems">
                <div class="invoice-card" *ngFor="let invoice of displayInvoiceList" (click)="onInvoiceClick(invoice)">
                  <div class="invoice-header">
                    <div class="invoice-title">
                      <div class="invoice-number">
                        <span class="label">Nota fiscal:</span>
                        <span class="value po-ml-2">{{ invoice.notaFiscal }}</span>
                      </div>
                      <div class="invoice-meta">
                        <div class="invoice-status" [ngClass]="{'status-completed': invoice.status === 'checked'}">
                          <span *ngIf="invoice.status === 'checked'" class="po-icon po-icon-ok"></span>
                        </div>
                        <span *ngIf="invoice.conferenceStatus" [ngClass]="getConferenceStatusInfo(invoice.conferenceStatus).class" class="po-ml-1">
                          <i class="po-icon" [class]="getConferenceStatusInfo(invoice.conferenceStatus).icon"></i>
                          <span class="po-ml-1">{{ getConferenceStatusInfo(invoice.conferenceStatus).text }}</span>
                        </span>
                      </div>
                    </div>
                    <div class="invoice-details">
                      <span class="label">Nº Pedido:</span>
                      <span class="value">{{ invoice.pedido }}</span>
                    </div>
                  </div>
                  <div class="invoice-body">
                    <div class="invoice-info">
                      <div class="info-row">
                        <span class="label">Empresa:</span>
                        <span class="value">{{ invoice.branchCode }}</span>
                      </div>
                      <div class="info-row">
                        <span class="label">Cliente:</span>
                        <span class="value">{{ invoice.fornecedor }}</span>
                      </div>
                      <div class="info-row">
                        <span class="label">Data emissão:</span>
                        <span class="value">{{ invoice.dataEmissao }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div class="loading-more" *ngIf="isLoadingMore">
                  <span class="po-icon po-icon-loading"></span>
                  <span class="po-ml-2">Carregando mais itens...</span>
                </div>
              </ng-container>
              <ng-template #innerNoItems>
                <div class="po-text-center po-mt-4 po-font-text-bold po-text-color-07">Sem itens para o filtro realizado</div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </po-container>
  </div>
</div>

<po-modal
  #modalSelectInvoice
  p-title="Selecione a Nota Fiscal"
  [p-click-out]="false"
  [p-hide-close]="false"
  [p-primary-action]="{ label: 'Confirmar', action: confirmInvoiceSelection.bind(this) }">
  <div class="po-row">
    <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
      <p class="po-font-text po-mb-2">Foram encontradas múltiplas notas fiscais com este número. Selecione a nota desejada:</p>
    </div>
  </div>
  <div class="po-row">
    <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
      <div class="invoice-selection-list">
        <div 
          *ngFor="let invoice of multipleInvoices" 
          class="invoice-selection-card"
          [class.selected]="selectedInvoice === invoice"
          (click)="onInvoiceSelect(invoice)">
          <div class="invoice-selection-header">
            <div class="invoice-selection-info">
              <div class="info-row">
                <span class="info-label">Número da NF:</span>
                <span class="info-value po-font-text-bold">{{ invoice.invoiceCode }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">Série:</span>
                <span class="info-value">{{ invoice.serialCode }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">Data de emissão:</span>
                <span class="info-value">{{ formatInvoiceDate(invoice.issueDate || invoice.invoiceDate) }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">Modalidade:</span>
                <span class="info-value">{{ invoice.modalityType || '-' }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">Valor da nota:</span>
                <span class="info-value">{{ invoice.invoiceValue || '-' }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">Cliente / Fornecedor:</span>
                <span class="info-value">{{ invoice.personName }}</span>
              </div>
              <div class="info-row" *ngIf="invoice.conferenceStatus">
                <span class="info-label">Status:</span>
                <span [ngClass]="getConferenceStatusInfo(invoice.conferenceStatus).class">
                  <i class="po-icon" [class]="getConferenceStatusInfo(invoice.conferenceStatus).icon"></i>
                  <span class="po-ml-1">{{ getConferenceStatusInfo(invoice.conferenceStatus).text }}</span>
                </span>
              </div>
            </div>
            <div class="invoice-selection-check" *ngIf="selectedInvoice === invoice">
              <span class="po-icon po-icon-ok"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</po-modal>